<% var component = new Anvil.models.components.GeoPicker(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col<%- ('width' in field) ? `-${field.width}` : '' %>">
	<div class="geo_picker_frame grid-wrapper" style="position:relative; width:100%; height:<%- field.height %>px; z-index:0;"></div>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<div class="geo_picker_frame grid-wrapper" style="position:relative; width:100%; height:<%- field.height %>px; z-index:0;"></div>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
